

export const handleChangeErrors = (name, value, estadoCampoReque, setEstadoCampoReque,setEstadosActualizados) => {

  let nuevoEstadoCampoReque = { ...estadoCampoReque };


  console.log("name", name);
  console.log("value", value);

  if (value == '') {
    nuevoEstadoCampoReque[name] = true;
  } else {
    nuevoEstadoCampoReque[name] = false;
  }


  setEstadoCampoReque(nuevoEstadoCampoReque);
  setEstadosActualizados(false);


};



export const handleSubmitErrors = (
  formData,
  estadoCampoReque,
  setEstadoCampoReque,
  camposRequeridos,
  setEstadosActualizados
) => {
  let nuevoEstadoCampoReque = { ...estadoCampoReque };


  for (const campo in camposRequeridos) {
    if (!formData[campo] || formData[campo].length == 0) {
      nuevoEstadoCampoReque[campo] = true;
    } else {
      nuevoEstadoCampoReque[campo] = false;
    }
  }

  setEstadoCampoReque(nuevoEstadoCampoReque);
  console.log("Nuevo estado de los campos requeridos:", nuevoEstadoCampoReque);

  setEstadosActualizados(true);
};



export const todosDatosCorrectos = (formData, estadoCampoReque) => {


  console.log("estadoCampoReque", estadoCampoReque);
  const formDataVacio = Object.values(formData).every(value => value === '');


  let todosCamposFalse = () => {
    const todosRequeFalse = Object.values(estadoCampoReque).every(valor => valor === false && !formDataVacio);

    return todosRequeFalse;
  };



  return {
    todosCamposFalse
  };
}